// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes scroll-left {
  0% {
    transform: translateX(120vw);
  }
  100% {
    transform: translateX(-100%);
  }
}
.scrolling-alert-wrapper {
  overflow: hidden;
  white-space: nowrap;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  position: relative;
  color: #856404;
}

.scrolling-alert-content {
  display: inline-block;
  white-space: nowrap;
  will-change: transform;
  animation: scroll-left 20s linear infinite;
}

/* Medium screens */
@media (max-width: 1024px) {
  .scrolling-alert-content {
    animation-duration: 15s;
  }
}
/* Small screens */
@media (max-width: 640px) {
  .scrolling-alert-content {
    animation-duration: 10s;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AlertNotifications/AlertNotification.scss"],"names":[],"mappings":"AAAA;EACE;IACE,4BAAA;EACF;EACA;IACE,4BAAA;EACF;AACF;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0CAAA;AAAF;;AAGA,mBAAA;AACA;EACE;IACE,uBAAA;EAAF;AACF;AAGA,kBAAA;AACA;EACE;IACE,uBAAA;EADF;AACF","sourcesContent":["@keyframes scroll-left {\n  0% {\n    transform: translateX(calc(120vw));\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.scrolling-alert-wrapper {\n  overflow: hidden;\n  white-space: nowrap;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n  width: 100%;\n  position: relative;\n  color: #856404;\n}\n\n.scrolling-alert-content {\n  display: inline-block;\n  white-space: nowrap;\n  will-change: transform;\n  animation: scroll-left 20s linear infinite;\n}\n\n/* Medium screens */\n@media (max-width: 1024px) {\n  .scrolling-alert-content {\n    animation-duration: 15s;\n  }\n}\n\n/* Small screens */\n@media (max-width: 640px) {\n  .scrolling-alert-content {\n    animation-duration: 10s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
